import React, { useEffect, useState } from 'react'
import FormHeader from './components/FormHeader'
import OverLoad from './components/OverLoad'
import DialogBox from './components/DialogBox';

function index() {
  const [typeError, setTypeError] = useState(null);
  const [excelFile, setExcelFile] = useState(null);
  const [excelData, setExcelData] = useState(null);
  const [openData , setOpenData] = useState(false);

  useEffect(() => {
    // console.log("excelData::::::::" , excelData);
    setOpenData(true);
  },[excelData])

 
 
  return (
    <div>
      <FormHeader setTypeError = {setTypeError} setExcelFile = {setExcelFile} setExcelData = {setExcelData} />
      {/* <OverLoad/> */}


      {openData && excelData && <DialogBox setOpenData = {setOpenData} excelData = {excelData}/>}
    </div>
  )
}

export default index
